import { getDvSumInformativeText } from "../../../../utils";
import { AddRuleFormConfigProps } from "../../addruleform.types";

import {
  FieldBase,
  SchemaType,
  SectionField,
} from "../../dynamicform/dynamicform.types";

export const addBlanksForm = ({
  columnSelectOptions,
  existingFilters,
  isEdit,
  isDisabled = false,
  isFromRuleSet,
  watchIncludeBlanks,
  watchIncludeEmpty,
  watchColumnType,
}: AddRuleFormConfigProps): SchemaType => {
  const {
    dat_dict_dat_qual_add_new_rle_pipln_flt: {
      description: datDictDatQualAddNewRleFndFlt = "",
    } = {},
  } = getDvSumInformativeText();

  return [
    ...((!isFromRuleSet &&
      !isEdit && [
        {
          id: "basic",
          type: "section",
          fields: [
            {
              id: "rule_type",
              type: "select",
              name: "rule_type",
              label: "Rule Type",
              required: true,
              disabled: true,
            },
            {
              id: "rule_description",
              type: "text_area",
              name: "rule_description",
              label: "Rule Description",
              placeholder: "Description",
              description: "",
            },
          ],
        } as SectionField,
      ]) ||
      []),
    {
      id: "basic_input",
      type: "section",
      title: isFromRuleSet ? "" : "Basic Input",
      fields: [
        ...((!isFromRuleSet && [
          {
            id: "column",
            type: "select",
            name: "column",
            label: "Column",
            showSearch: true,
            disabled: isDisabled,
            required: true,
            options: columnSelectOptions as { value: string; label: string }[],
            placeholder: "Select",
          } as FieldBase,
        ]) ||
          []),

        ...((watchColumnType !== "DEC" &&
          watchColumnType !== "DTE" &&
          watchColumnType !== "NUM" &&
          watchColumnType !== "INT" && [
            {
              id: "include_empty",
              type: "checkbox",
              name: "include_empty",
              label: "Treat Empty Strings as Blanks",
              disabled: !watchIncludeBlanks,
              // description: datDictDatQualAddNewRleFndStrProc,
            },
          ]) ||
          []),
        {
          id: "include_blanks",
          type: "checkbox",
          name: "include_blanks",
          label: "Treat Null Values as Blanks",
          disabled: !watchIncludeEmpty,
          // description: datDictDatQualAddNewRleFndStrProc,
        },

        ...((!isFromRuleSet && [
          {
            id: "filter_criteria",
            type: "filter",
            name: "filter_criteria",
            label: "Filter Condition",
            description: datDictDatQualAddNewRleFndFlt,
            existingFilters,
          } as FieldBase,
        ]) ||
          []),
      ],
    },
  ];
};
